import { AddButton, InputText, Loading } from "@bluframe/blublocks"
import Pagination from "components/Pagination"

import { ComponentProps } from "."
import Item from "./Item"
import { H1, ItemsUl, Li, NoItems, Top, Wrapper } from "./styled"

const List = ({
  hasAdd = true,
  hasSearch,
  isAdmin,
  isEditor,
  isSearchLoading,
  items,
  label,
  loading,
  onAdd,
  onSearchChange,
  pagination,
  searchRef
}: ComponentProps) => (
  <Wrapper>
    <Top>
      <H1>{label}</H1>

      {hasAdd ? (
        <AddButton label={`Add ${label}`} onClick={onAdd} size="36px" />
      ) : null}
    </Top>

    {hasSearch ? (
      <InputText
        inputId="search"
        label={`Search ${label}`}
        name="search"
        onChange={onSearchChange}
        ref={searchRef}
      />
    ) : null}

    {pagination ? <Pagination {...pagination} /> : null}

    {loading || isSearchLoading ? <Loading /> : null}

    {items ? (
      <ItemsUl aria-label={label}>
        {items.map((item) => (
          <Li aria-label={item.label} key={item.id}>
            <Item {...item} isAdmin={isAdmin} isEditor={isEditor} />
          </Li>
        ))}
      </ItemsUl>
    ) : null}

    {!items?.length && !loading && !isSearchLoading ? (
      <NoItems>{"No items found!"}</NoItems>
    ) : null}

    {pagination ? <Pagination {...pagination} /> : null}
  </Wrapper>
)

export default List
